import { URLS } from '../../config/api-config';
import { ISfconfigType } from '../../types/app-interfaces';
import { showFloatingButton, updateFloatingButtonText } from '../button-utils/custom-button-utils';
import { isSafari } from '../app-utils/mobile-utils';
import { WindowType } from '../../types/global-window-type';
import { logNR } from '../app-utils/nr-logging';

declare const window: WindowType;
/** Returns the type of button/config to be used for the page */

export const getSfConfigType = (type?: ISfconfigType) => type || 'default';

export const hideEmbeddedContainer = () => {
  const embeddedContainer = document.querySelector('.embeddedMessagingFrame');
  console.info('hiding Embedded container', embeddedContainer);
  if (embeddedContainer instanceof HTMLElement) {
    embeddedContainer.style.display = 'none';
    showFloatingButton();
    const agentName = sessionStorage.getItem('AgentName');
    if (agentName) updateFloatingButtonText(agentName);
    window.isChatMinimized = true;
  }
};

export const playNotification = () => {
  try {
    if (!isSafari()) {
      const audio = new Audio(URLS.NOTIFICATION_SOUND);
      audio.play();
    } else {
      let audioContext;
      if (window?.AudioContext) audioContext = new window.AudioContext();
      // eslint-disable-next-line new-cap
      else if (window?.webkitAudioContext) audioContext = new window.webkitAudioContext();
      if (audioContext) {
        const audioSource = audioContext?.createBufferSource();
        if (audioSource) {
          fetch(URLS.NOTIFICATION_SOUND)
            .then((response) => response.arrayBuffer())
            .then((data) => audioContext.decodeAudioData(data))
            .then((buffer) => {
              audioSource.buffer = buffer;
              audioSource.connect(audioContext.destination);
              audioSource.start();
            })
            .catch((error) => console.error(error));
        }
      }
    }
  } catch (e) {
    const error = e as Error;
    console.error('Error playing notification sound: ', e);
    logNR('CA_ERROR', { errorMessage: error.message, errorStack: error.stack });
  }
};

// Helper: Locale day mappings
export const getLocaleDays = (locale) => {
  switch (locale) {
    case 'fr-ca':
    case 'fr-fr':
    case 'fr-ch':
    case 'fr-be':
      return {
        Sun: 'Dim',
        Mon: 'Lun',
        Tue: 'Mar',
        Wed: 'Mer',
        Thu: 'Jeu',
        Fri: 'Ven',
        Sat: 'Sam',
      };
    case 'es-us':
    case 'es-es':
      return {
        Sun: 'Dom',
        Mon: 'Lun',
        Tue: 'Mar',
        Wed: 'Mié',
        Thu: 'Jue',
        Fri: 'Vie',
        Sat: 'Sáb',
      };
    case 'it-it':
    case 'it-ch':
      return {
        Sun: 'Dom',
        Mon: 'Lun',
        Tue: 'Mar',
        Wed: 'Mer',
        Thu: 'Gio',
        Fri: 'Ven',
        Sat: 'Sab',
      };
    case 'nb-no':
      return {
        Sun: 'Søn',
        Mon: 'Man',
        Tue: 'Tir',
        Wed: 'Ons',
        Thu: 'Tor',
        Fri: 'Fre',
        Sat: 'Lør',
      };
    case 'de-de':
    case 'de-at':
    case 'de-ch':
      return {
        Sun: 'Son',
        Mon: 'Mon',
        Tue: 'Die',
        Wed: 'Mit',
        Thu: 'Don',
        Fri: 'Fre',
        Sat: 'Sam',
      };
    case 'nl-nl':
    case 'nl-be':
      return {
        Sun: 'Zon',
        Mon: 'Maa',
        Tue: 'Din',
        Wed: 'Woe',
        Thu: 'Don',
        Fri: 'Vri',
        Sat: 'Zat',
      };
    case 'sv-se':
      return {
        Sun: 'Sön',
        Mon: 'Mån',
        Tue: 'Tis',
        Wed: 'Ons',
        Thu: 'Tor',
        Fri: 'Fre',
        Sat: 'Lör',
      };
    case 'pt-pt':
      return {
        Sun: 'Dom',
        Mon: 'Seg',
        Tue: 'Ter',
        Wed: 'Qua',
        Thu: 'Qui',
        Fri: 'Sex',
        Sat: 'Sab',
      };
    case 'da-dk':
      return {
        Sun: 'Søn',
        Mon: 'Man',
        Tue: 'Tir',
        Wed: 'Ons',
        Thu: 'Tor',
        Fri: 'Fre',
        Sat: 'Lør',
      };
    case 'fi-fi':
    case 'en-us':
    case 'en-ca':
    case 'en-gb':
    case 'en-ie':
    case 'en-au':
    case 'en-nz':
    case 'en-sg':
    case 'en-in':
    default:
      return {
        Sun: 'Sun',
        Mon: 'Mon',
        Tue: 'Tue',
        Wed: 'Wed',
        Thu: 'Thu',
        Fri: 'Fri',
        Sat: 'Sat',
      };
  }
};
